/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Mode_InvalidInputs */

const vi_error_irrigation_schedule_mode_invalid = /** @type {(inputs: Error_Irrigation_Schedule_Mode_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chế độ lịch không hợp lệ, vui lòng chọn lại`)
};

/**

* @param {Error_Irrigation_Schedule_Mode_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_mode_invalid = /** @type {((inputs?: Error_Irrigation_Schedule_Mode_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Mode_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_mode_invalid(inputs)
});